import {tail} from 'lodash'

import clsx from 'clsx'
import React from 'react'
import {useHistory} from 'react-router-dom'
import { makeStyles, withStyles} from 'external/material'

import SearchPattern from   'components/search-pattern'
import ClearableSelect from 'components/clearable-select'

import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'

const useStyles = makeStyles(filterStyles)

export default function HomeworkFilters({context}) {

  const classes = useStyles()
  const history = useHistory()
  const {translate, link, linkQuery, tab, myCourses, groups} = context
  const createFilterHandler = (name, mapQuery) => (event) => {
    const value = event.target.value == '' ? undefined : event.target.value
    const query = mapQuery
      ? mapQuery(context.query, value)
      : {...context.query, [name]: value}
    history.push(linkQuery(link(), {...query}))
  }


  return (<Box className={classes.root}>
    
      <Box className={classes.filters}>
        {groups.length > 0 && (
        <ClearableSelect
            id="homework-group-filter"
            className={clsx(classes.select, "group")}
            value={context.query.group || ""}
            onChange={createFilterHandler('group')}
            caption={translate('group_label')}
        >
            {groups.map(group => {
            return (<MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>)
            })}
        </ClearableSelect>)}
      
            
      <Box className={classes.pattern}>
        <SearchPattern path={context.link()} context={context} />
      </Box>
    </Box>
  </Box>
  )
}

function filterStyles() {

    return {
        root: {
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        },
        filters: {
          flexGrow: 1,
          marginTop: 10,
          display: "flex"
        },
        select: {
          marginLeft: 15,
          '&:first-child': {
            marginLeft: 0
          },
          '&:last-child': {
            marginRight: 15
          },
          '&.type': {
            flexGrow: 1,
            minWidth: 120,
          },
          '&.group': {
            flexGrow: 1,
            minWidth: 120,
            maxWidth: 300
          },
          '&.course': {
            flexGrow: 1,
            minWidth: 120,
            maxWidth: 300
          },
        },
        filler: {
          flexGrow: 1,
        },
        pattern: {
          marginLeft: 15,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          
          border: 'solid 1px #bec4d2',
          display: 'flex',
          flexWrap: 'nowrap',
          borderRadius: '3px',
          backgroundColor: '#fff',
          padding: 0,
          height: 39,
          marginTop: 16,          
        }
      }
}

/*


      {context.subjects.length > 0 && (
        <ClearableSelect
          id="quiz-subject-filter"
          className={clsx(classes.select, "subject")}
          value={context.query.subject || ""}
          onChange={createFilterHandler('subject', (query, subject) => ({...query, course: undefined, subject}))}
          caption={translate('subject_label')}
        >
          {context.subjects.map((subject, key) => {
            return (<MenuItem value={subject.id} key={key}>{subject.name}</MenuItem>)
          })}
        </ClearableSelect>
      )}
      

*/
